<template lang="pug">
  #CustomerTextPushModel.CustomerModel.CustomerModel-textPushModel.p-3(
    :class="{ 'CustomerModel-active': showModel }",
    :style="[{Zindex: Zindex}, modelCSS]"
  )
    .row.align-items-start.mb-2
      .col-10
        h2.mb-0 {{ title }}
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .content.mb-2
      p.mb-3 訊息內容：(請輸入文字)
      b-form-textarea(
        rows="10",
        v-model="text"
      )
      small.text-muted.text-right.d-block 文字數：{{ text ? text.length : 0 }}
    .px-4
      .row
        .col-12.justify-content-center
          button.btn.btn-block.btn-primary(
            type="button",
            @click="submitHandler()"
          ) 送出

</template>

<script>
import IconCloseUrl from '@/assets/images/icon/icon_close.png';

export default {
  name: 'TempTextModel',
  props: {
    title: {
      type: String,
      default: ''
    },
    Zindex: {
      type: String,
      default: '15px'
    },
    modelCSS: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      text: null
    };
  },
  mounted() {
    const vm = this;
    vm.$EventBus.$on('openTextPushModel', () => {
      vm.openModel();
    });
  },
  methods: {
    initHandler() {
      this.text = null;
    },
    openModel() {
      this.initHandler();
      this.showModel = true;
    },
    closeModel() {
      this.initHandler();
      this.showModel = false;
    },
    submitHandler() {
      const vm = this;

      if (!vm.text || vm.text.length === 0) {
        vm.$swal.fire({
          icon: 'error',
          title: '文字訊息內容尚未填寫'
        });
      } else {
        vm.$emit('sendHandler', {
          type: 'text',
          text: vm.text
        });

        vm.closeModel();
      }
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openTextPushModel');
  }
};
</script>

<style>

</style>
